import React from 'react';
import { ScoreCell } from 'components/scores';

const LeaderboardCellRound = ({ data }) => {
    let scoreText = data;

    if (!data || data === '0') {
        scoreText = '-';
    }

    return (
        <div className="leaderboard__cell leaderboard__cell--round">
            <div className="leaderboard__cell-content">
                <ScoreCell
                    childCss='leaderboard__score-cell'
                    bemList={['default', 'has-border']}
                >{scoreText}</ScoreCell>
            </div>
        </div>
    );
};

export default LeaderboardCellRound;
